import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ShowdownDirective } from '../../../directives/animations/showdown.directive';
import { Logo } from '../../common/logo/logo';

@Component({
  selector: 'section[app-about-us-section]',
  imports: [Logo, ShowdownDirective],
  templateUrl: './about-us-section.html',
  styleUrl: './about-us-section.scss',
})
export class AboutUsSection {
  get appname(): string {
    return environment.appname;
  }
}
